import {Component, EventEmitter, HostBinding, Input, OnChanges, Output,} from '@angular/core';
import {NavItem} from './nav-item';
import {Router} from '@angular/router';
import {NavService} from '../../../../../services/nav.service';
import {animate, state, style, transition, trigger,} from '@angular/animations';
import {TablerIconsModule} from 'angular-tabler-icons';
import {MaterialModule} from 'src/app/material.module';
import {CommonModule} from '@angular/common';
import {CoreService} from 'src/app/services/core.service';
import {PermissionService} from 'src/core/authorization/permission.service';
import {LocalizationPipe} from '../../../../../pipe/localization-pipe';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
    selector: 'app-nav-item',
    imports: [LocalizationPipe, TablerIconsModule, MaterialModule, CommonModule],
    templateUrl: './nav-item.component.html',
    styleUrls: [],
    standalone: true,
    animations: [
        trigger('indicatorRotate', [
            state('collapsed', style({transform: 'rotate(0deg)'})),
            state('expanded', style({transform: 'rotate(180deg)'})),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4,0.0,0.2,1)')),
        ]),
    ]
})
export class AppNavItemComponent implements OnChanges {
    @Output() toggleMobileLink: any = new EventEmitter<void>();
    @Output() notify: EventEmitter<boolean> = new EventEmitter<boolean>();

    expanded: any = false;
    disabled: any = false;
    twoLines: any = false;
    @HostBinding('attr.aria-expanded') ariaExpanded = this.expanded;
    @Input() item: NavItem | any;
    @Input() depth: any;

    options = this.coreService.getOptions();

    constructor(
        public navService: NavService,
        public router: Router,
        private coreService: CoreService,
        private permissionService: PermissionService,
        public themeService: ThemeService
    ) {
        if (this.depth === undefined) {
            this.depth = 0;
        }
    }

    ngOnChanges() {
        const url = this.navService.currentUrl();
        if (this.item.route && url) {
            this.expanded = url.indexOf(`/${this.item.route}`) === 0;
            this.ariaExpanded = this.expanded;
        }
        // Always refresh options to get latest theme
        this.options = this.coreService.getOptions();
        this.themeService.applyCurrentTheme();
    }

    onItemSelected(item: NavItem) {
        if (!item.children || !item.children.length) {
            this.router.navigate([item.route]);

        }
        if (item.children && item.children.length) {
            this.expanded = !this.expanded;
        }
        //scroll
        window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
        if (!this.expanded) {
            if (window.innerWidth < 1024) {
                this.notify.emit();
            }
        }
    }

    onSubItemSelected(item: NavItem) {
        if (!item.children || !item.children.length) {
            if (this.expanded && window.innerWidth < 1024) {
                this.notify.emit();
            }
        }
    }

    // Yetki kontrolü için metod
    checkPermission(item: NavItem): boolean {
        if (!item.permissions) {
            return true; // Eğer izin belirlenmemişse, erişime izin ver
        }
        return this.permissionService.hasPermission(item.permissions);
    }

    checkExistHaveOrganisation(item: NavItem): boolean {
        if (item.existHaveOrganisation == true) {
            return window.globalActiveUser && window.globalActiveUser.organisationAccount != undefined;
        } else if (item.existHaveOrganisation == false) {
            return window.globalActiveUser && window.globalActiveUser.organisationAccount == undefined;
        }
        return true;

    }

    protected readonly window = window;
}
